import Section from "../Section"
import styles from "./TextImageGrid.module.scss"
import cx from "classnames"
import Image from "../Image"
import Link from "../Link"

const TextImageGrid = ({ data }) => {
  const {
    section_teaser,
    section_headline,
    section_subline,
    section_text,
    section_links,
    text_image_grid_items: items,
  } = data

  return (
    <Section
      teaser={section_teaser}
      headline={section_headline}
      subline={section_subline}
      text={section_text}
      links={section_links}
    >
      <div className={styles.textImageGrid}>
        {items?.length > 0 &&
          items.map((item, i) => (
            <div
              key={i}
              className={cx(styles.item, "@container", {
                [styles.evenItem]: i % 2 === 1,
                [styles.lastOddItem]: i === items.length - 1 && i % 2 === 0,
              })}
            >
              <div className="@xl:flex @xl:gap-10">
                {item.image && (
                  <div
                    className={cx(
                      styles.image,
                      "@xl:w-1/2 relative min-h-[27rem]"
                    )}
                  >
                    {item?.image && (
                      <Image
                        alt={item.image?.alt}
                        src={item.image?.permalink}
                        fill
                        style={{
                          objectFit: "cover",
                          objectPosition: `${
                            item.image?.focus_css || "center"
                          }`,
                        }}
                      />
                    )}
                  </div>
                )}
                <div
                  className={cx(
                    styles.content,
                    "@xl:w-1/2 @xl:flex @xl:flex-col @xl:justify-center"
                  )}
                >
                  {item.teaser && (
                    <div
                      className={styles.teaser}
                      dangerouslySetInnerHTML={{ __html: item.teaser }}
                    />
                  )}
                  {item.headline && (
                    <h2
                      className={styles.headline}
                      dangerouslySetInnerHTML={{ __html: item.headline }}
                    />
                  )}
                  {item.subline && (
                    <div
                      className={styles.subline}
                      dangerouslySetInnerHTML={{ __html: item.subline }}
                    />
                  )}
                  {item.text && (
                    <div
                      className={styles.text}
                      dangerouslySetInnerHTML={{ __html: item.text }}
                    />
                  )}
                  {item.links?.length > 0 && (
                    <div className={styles.links}>
                      {item.links.map((link, i) => (
                        <Link key={i} link={link} className="!p-0" />
                      ))}
                    </div>
                  )}
                </div>
              </div>
            </div>
          ))}
      </div>
    </Section>
  )
}

export default TextImageGrid
